import { render, staticRenderFns } from "./orderProcess.vue?vue&type=template&id=c8d3476a&scoped=true"
import script from "./orderProcess.vue?vue&type=script&lang=js"
export * from "./orderProcess.vue?vue&type=script&lang=js"
import style0 from "./orderProcess.vue?vue&type=style&index=0&id=c8d3476a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d3476a",
  null
  
)

export default component.exports